export const STAND_CREATION_FORM_MAX_LENGTHS = {
  standName: 100,
  standAreaMaintenanceNotes: 150,
};

export const DEFAULT_STAND_TYPE = 'NORMAL'
